export default __webpack_public_path__ + "static/media/Illo_BAC.401d7bb6.svg";